/**
 *
 * @module entry
 * @desc {SDK.Internal} entry point.
 *
 */

import Dust from './dust/entry';
import Telemetry from './telemetry/entry';

/**
 *
 * @typedef SDK.Internal
 * @type {Object}
 *
 * @property {Dust} Dust
 * @property {Telemetry} Telemetry
 *
 */

/**
 *
 * @type {SDK.Internal}
 *
 */
export default {

    Dust,
    Telemetry

};



// WEBPACK FOOTER //
// ./src/internal/entry.js